var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCustomerBehavior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8a5 5 0 01-5 5 6 6 0 00-6 6 1 1 0 11-2 0 8.001 8.001 0 014.666-7.274A5 5 0 1116 8zm-5-3a3 3 0 100 6 3 3 0 000-6zM12.947 13.923A3.244 3.244 0 0117 13.536a3.244 3.244 0 014.053.387 3.145 3.145 0 010 4.499L17.7 21.713a1 1 0 01-1.402 0l-3.352-3.291a3.145 3.145 0 010-4.5zm1.402 1.427a1.241 1.241 0 011.727 0l.223.22a1 1 0 001.402 0l.223-.22a1.241 1.241 0 011.727 0 1.145 1.145 0 010 1.645L17 19.599l-2.651-2.604a1.145 1.145 0 010-1.645z",
    fill: "#fff"
  })));
}

export default SvgIbCustomerBehavior;